import { api } from './client';

export interface CreateFeedbackPayload {
  content: string;
}

export async function submitFeedback(payload: CreateFeedbackPayload): Promise<void> {
  await api.post('/feedback', payload);
}

export interface FeedbackUser {
  id: string;
  email: string;
  role: string;
  firstName: string | null;
  lastName: string | null;
}

export interface FeedbackItem {
  id: string;
  userId: string;
  content: string;
  createdAt: string;
  user: FeedbackUser;
}

export interface ListFeedbacksParams {
  role?: 'CLIENT' | 'ASSOCIATE';
  page?: number;
  pageSize?: number;
}

export interface ListFeedbacksResponse {
  items: FeedbackItem[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export async function listFeedbacks(
  params: ListFeedbacksParams = {},
): Promise<ListFeedbacksResponse> {
  const { data } = await api.get<ListFeedbacksResponse>('/feedback/admin', { params });
  return data;
}
